import { Link } from "Components/Header";

export const HeaderLinks: Link[] = [
    { label: "Dashboard", path: "/", authRequired: true },
    { label: "Latest", path: "/latest", authRequired: true }
];